import styled from 'styled-components'
import Text from '../../text'

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};
  width: 100%;
`

export const StyledCard = styled.div`
  width: 100%;
  padding: 2rem 3rem;
  background: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%),
    0 1px 3px 0 rgb(0 0 0 / 12%);
  cursor: pointer;
  transition: all 0.4s;
  direction: rtl;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  &:hover ${StyledLink} {
    color: ${(props) => props.theme.colors.white};
  }
  &:hover {
    color: ${(props) => props.theme.colors.white};
    background: ${(props) => props.theme.colors.red};
    transform: translateY(-8px);
  }
  @media (max-width: ${(props) => props.theme.responsive.tablet}) {
    padding: 2rem 1rem;
    width: 19rem;
  }
  @media (max-width: ${(props) => props.theme.responsive.mobileS}) {
    padding: 2rem 1rem;
    width: 15rem;
  }
`

export const StyledIcon = styled(Text)`
  display: flex;
  align-items: center;
`

export const StyledIcons = styled(Text)`
  display: flex;
  gap: 2rem;
`
